export default "__VITE_ASSET__CcDtvLJZ__"